import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from "lucide-react";
import type { SamplePage } from "../types/offer";
type SampleLightboxProps = {
  pages: SamplePage[];
  index: number;
  onClose: () => void;
  onChange: (index: number) => void;
};
export function SampleLightbox({
  pages,
  index,
  onClose,
  onChange
}: SampleLightboxProps) {
  const page = pages[index];
  const prev = () => onChange((index - 1 + pages.length) % pages.length);
  const next = () => onChange((index + 1) % pages.length);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  });
  return <motion.div role="dialog" aria-modal="true" aria-label={page.caption} className="fixed inset-0 z-50 flex flex-col bg-night/95" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-230" data-mp="2ql9dzed1cda8">
      <div className="flex items-center justify-between gap-4 px-4 py-3 text-white" data-id="element-231" data-mp="2vkm9solvwuoy">
        <span className="text-sm" data-id="element-232" data-mp="39k568k5c2hlf">
          <span className="text-gold" data-id="element-233" data-mp="39j3vkgs8bx48">{index + 1}</span> / {pages.length} · {page.caption}
        </span>
        <button type="button" onClick={onClose} aria-label="Cerrar" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/10 transition-colors duration-150 ease-out hover:bg-white/20" data-id="element-234" data-mp="35ijx99vx6ngi">
          <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-235" data-mp="3t7uuwihz41qf" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-4 pb-24" onClick={onClose} data-id="element-236" data-mp="3oa32lndf2dlp">
        <img src={page.src} alt={page.alt} onClick={e => e.stopPropagation()} className="mx-auto block h-auto w-full max-w-[560px] rounded-xl" data-id="element-237" data-mp="3o7qd8p5bx0ym" />
      </div>
      <div className="pointer-events-none fixed inset-x-0 bottom-6 flex justify-center gap-3" data-id="element-238" data-mp="95jga4bp5slw">
        <button type="button" onClick={prev} aria-label="Página anterior" className="pointer-events-auto flex h-12 w-12 items-center justify-center rounded-full bg-cta text-white shadow-[0_4px_0_#164BBB]" data-id="element-239" data-mp="dw9ix9sqnhcw">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-240" data-mp="mvd3yjbgu6u1" />
        </button>
        <button type="button" onClick={next} aria-label="Página siguiente" className="pointer-events-auto flex h-12 w-12 items-center justify-center rounded-full bg-cta text-white shadow-[0_4px_0_#164BBB]" data-id="element-241" data-mp="rx2jab5q16nx">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-242" data-mp="2ymh3da1zutq6" />
        </button>
      </div>
    </motion.div>;
}